import { Link } from 'react-router-dom';
import { useState } from "react";
import './navbar.css';

const Navbar = () => {
   const [menuOpen, setMenuOpen] = useState(false);
  return (
    <nav class = "navbar">
      <div 
        className="hamburger"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        ☰
      </div>
      <div class = "header">
        <ul className={menuOpen ? "nav-links active" : "nav-links"}>
          <li><a href="#about">About</a></li>
          <li><a href="#service">Services</a></li>
          <li><a href="#portfolio">Portfolio</a></li>
          <li><a href="#contact">Contact</a></li>
          <li>
            <div className="pulsing-border">
              <Link to="https://calendly.com/drecook16/30min" >Book Consultation</Link>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;